<template>
  <div>
    <Modal v-model="visible" width="1400px" title="合同预览" :footer-hide="true" :mask-closable="false" class="my-modal top p-b">
      <div class="contract-list">
        <Tabs v-model="tabId" :animated="false">
          <TabPane
            v-for="(bean, i) in fileList"
            :key="bean.id"
            :label="bean.fileName && bean.fileName.substr(0, bean.fileName.length - 4)"
            :name="i + ''"
          ></TabPane>
        </Tabs>
        <iframe
          class="iframe"
          :src="fileList.length && fileList[tabId].path"
          frameborder="0"
          
          v-if="fileList.length && fileList[tabId].path.indexOf('pdf') != -1"
        ></iframe>
        <noData v-else :seizeText="fileList.length ? '暂只支持PDF文件' : '暂无可预览文件'"></noData>
      </div>
    </Modal>
  </div>
</template>

<script>
import noData from '@/components/commons/noData';
export default {
  components: { noData },
  data() {
    return {
      tabId: 0,
      fileList: [],
      visible: false,
      curData: {},
      tableH: null
    };
  },
  created() {
    window.addEventListener('resize', () => {
      this.tableH = document.body.clientHeight - 385;
      console.log(this.tableH)
    });
  },
  methods: {
    open(fileList) {
      this.fileList = fileList && JSON.parse(fileList);
      this.tabId = 0;
      this.visible = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.contract-list {
  .iframe {
    width: 100%;
    height:68vh;
  }
}
.hide-arrow-left {
  /deep/ .ivu-tabs-nav-prev {
    display: none;
  }
}
.hide-arrow-right {
  /deep/ .ivu-tabs-nav-next {
    display: none;
  }
}
</style>
